import React from 'react';
import Typography from '@material-ui/core/Typography';
import { experimentalStyled } from '@material-ui/core/styles';
import dayjs from 'dayjs';
import Box from '@material-ui/core/Box';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);
var HeaderBoxStyles = {
  display: 'grid',
  gridTemplateColumns: 'minContent maxContent',
  gridTemplateRows: '1fr',
  gap: '1em 1em',
  gridTemplateAreas: "\n    \"Avatar Headings\"\n  ",
  '& .Avatar': {
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: '3em',
      height: '3em'
    }
  },
  '& .Headings': {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridTemplateRows: 'minContent minContent',
    gap: '1px 1px',
    gridTemplateAreas: "\n      \"Name\"\n      \"Date\"\n    ",
    gridArea: 'Headings',
    alignItems: 'center'
  }
};
var HeaderBox = experimentalStyled(Box)(HeaderBoxStyles);

var Header = function Header(_ref) {
  var toDate = _ref.toDate,
      user = _ref.user,
      avatar = _ref.avatar;
  var firstName = user.firstName,
      lastName = user.lastName;
  return /*#__PURE__*/React.createElement(HeaderBox, null, /*#__PURE__*/React.createElement("div", {
    className: "Avatar"
  }, /*#__PURE__*/React.createElement("img", {
    src: avatar.url,
    alt: "".concat(firstName, " ").concat(lastName)
  })), /*#__PURE__*/React.createElement("div", {
    className: "Headings"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Name"
  }, "".concat(firstName, " ").concat(lastName))), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textSecondary"
  }, /*#__PURE__*/React.createElement("div", {
    className: "Date"
  }, dayjs(toDate).format('dddd, MMMM Do')))));
};

export { Header };